<template>
  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>

  <div class="cell small-12">
    <h1>Anticipated Go-Live Date</h1>
    <p>To allow us to allocate resources to deliver the onboarding project, please provide the anticipated go-live date for {{ formData.clientName }}. The go-live date is the payslip date of your first live payroll.</p>
    </div>

    <div class="cell small-5">
      <form class="fieldset" @submit.prevent> 
          <label>Anticipated Go-Live Date</label>
          <DateInput v-model="formData.goLiveDate" name="intendedGoLiveDate" />

      </form>
    </div>
  


</template>


<script setup>

import { ref, onMounted  } from 'vue'
import DateInput from '@/components/controls/DateInput.vue'
import { postIntermediaryClientSignup } from '@/services/clientsignupmanager.func';

const error = ref([]);

const props = defineProps({
  formData: Object
})


const validateStep = () => {

  error.value = [];

  if (!props.formData.goLiveDate) {
    error.value.push('Please select an anticipated go-live date.');
  }
  if (error.value.length > 0) return false;


  return true;
}




const executeStep = async () => {
  
  const res = await postIntermediaryClientSignup(props.formData);
  if (res.status !== 202) {
    error.value.push('Sorry, we\'ve been unable to create your account, please contact your Qtac account manager.');
    return false;
  }


  return true;
}



onMounted(() => {

});

defineExpose({ validateStep, executeStep });

</script>